/**
 * Helper function to render CSS classes based on component state
 */
export const renderGridItemClasses = (
  isDisabled: boolean,
  isActive: boolean,
  limitStatus?: 'none' | 'limit' | 'range',
): string => {
  const baseClasses =
    'flex items-center justify-center py-3 px-4 border font-semibold text-sm transition-all'

  if (isDisabled) {
    return `${baseClasses} bg-[var(--grid-item-disabled-bg)] text-[var(--grid-item-disabled-text)] border-[var(--grid-item-disabled-border)] cursor-not-allowed`
  }

  if (limitStatus === 'limit') {
    return `${baseClasses} bg-[var(--grid-item-disabled-bg)] text-[var(--grid-item-disabled-text)] border-[var(--grid-item-disabled-border)] cursor-not-allowed`
  }

  if (isActive) {
    return `${baseClasses} active-gradient border-[var(--grid-item-active-border)] cursor-pointer`
  }

  if (limitStatus === 'range') {
    return `${baseClasses} bg-[var(--grid-item-range-limit-bg)] text-[var(--grid-item-range-limit-text)] border-[var(--grid-item-range-limit-border)] cursor-pointer`
  }

  return `${baseClasses} bg-[var(--grid-item-bg)] text-[var(--grid-item-text)] border-[var(--grid-item-border)] hover:bg-[var(--grid-item-hover-bg)] hover:text-[var(--grid-item-hover-text)] hover:border-[var(--grid-item-hover-border)] cursor-pointer`
}
